define('lib/check-first-visit',['require','exports','module','jquery'],function (require, exports, module) {
    var $ = require('jquery');

    var waitingForValue = $.Deferred();

    module.exports = {
        set: function (isFirstLogin) {
            waitingForValue.resolve(isFirstLogin);
        },

        check: function () {
            return waitingForValue;
        }
    };
});

